import React, { useRef } from "react"
import clsx from "clsx"

import type { Maybe } from "~/types/ts-utils"
import { useIsDonating } from "~/utils/donations"

import {
  ArticleAudioPlayer,
  ProgressBar,
  useDuration,
  useIsPlaying,
} from "./ArticleAudioPlayer"
import type { BookmarkerProps } from "./Bookmarker"
import { Bookmarker } from "./Bookmarker"
import type { ShareLinksProps } from "./ShareLinks"
import { ShareLinks } from "./ShareLinks"

export type StickyBarProps = {
  audioURL: Maybe<string>
  articleUID: string
} & ShareLinksProps &
  BookmarkerProps

export const StickyBar: React.FC<StickyBarProps> = ({
  audioURL,
  title,
  path,
  articleUID,
}) => {
  const isDonating = useIsDonating()

  const audioRef = useRef<HTMLAudioElement>(null)
  const [isPlaying] = useIsPlaying()
  const [duration] = useDuration()

  return (
    <>
      <div className={clsx("sticky top-0 z-10 mx-auto mb-8 max-w-screen-lg")}>
        <div
          className={clsx(
            "bg-white dark:bg-primary-900",
            "border-b border-gray-300 dark:border-primary-200",
          )}
        >
          <div
            className={clsx(
              "flex items-center justify-end",
              "mx-auto space-x-4 py-2 px-4 md:py-4",
            )}
          >
            <div className="mr-auto">
              {isDonating && audioURL && (
                <ArticleAudioPlayer url={audioURL} audioRef={audioRef} />
              )}
            </div>

            <ShareLinks title={title} path={path} />
          </div>

          {isPlaying || !!duration ? (
            <ProgressBar player={audioRef.current} />
          ) : null}
        </div>
        <div className="sticky top-0 p-2 md:p-4">
          <div className="absolute top-2 right-2 md:top-4 md:right-4">
            <Bookmarker articleUID={articleUID} />
          </div>
        </div>
      </div>
    </>
  )
}
